module.exports = __webpack_public_path__ + "img/plus-circle.440b6671.svg";